import { css } from 'styled-components';
import { theme } from 'modules/tetrisTheme';
export function getStylesBySelected() {
    return css `
    background-color: ${theme.semantic.surface.sunken};
    color: ${theme.semantic.foreground.primary};

    &:disabled {
      background-color: ${theme.semantic.action.primary.disabled};
      color: ${theme.swatches.warm[500]};
    }
  `;
}
